import Drawer from "@material-ui/core/Drawer";
import useStyles from "../../../styles";
import CloseIcon from "@material-ui/icons/Close";
import { Avatar, Collapse, Grid } from "@material-ui/core";
import useOutSideClick from "../../../utilize/Hook/useOutSideClick";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import homeMobile from "../../../assets/icon/homeMobile.svg";
import activities from "../../../assets/icon/activities.svg";
import ligue from "../../../assets/icon/ligue.svg";
import speak from "../../../assets/icon/speak.svg";
import RememberIcon from "../../../assets/icon/mobile-menu/rememberIcon.svg";
import TourIcon from "../../../assets/icon/mobile-menu/tourIcon.svg";
import EducationalIcon from "../../../assets/icon/mobile-menu/educationalIcon.svg";
import CounterIcon from "../../../assets/icon/mobile-menu/counterIcon.svg";
import DanaBazarIcon from "../../../assets/icon/mobile-menu/danaBazarIcon.svg";
import resetPassword from "assets/icon/resetPassword.svg";
import outlineUser from "../../../assets/icon/outlineUser.svg";
import exitIcon from "../../../assets/icon/exitIcon.svg";
import history from "../../../utilize/history";
import { logOut, setNotificationsSeen } from "../../../routes/actions";
import Apis from "../../../constants/Api";
import axios from "axios";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import { setTour } from "routes/actions";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  BackspaceOutlined,
  ExitToAppRounded,
  GroupRounded,
  PeopleOutline,
  PersonOutlined,
} from "@material-ui/icons";

export default function DrawerMenu({ open, handleClose }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [remember, setRemember] = useState(false);
  const { currentUser } = useSelector((state) => state.main);
  const tour = useSelector((state) => state.main.tour);
  const [seeMore, setSeeMore] = useState(false);
  const [showElection, setShowElection] = useState(false);
  const [showElectionFade, setShowElectionFade] = useState(false);
  const [showAghighSchool, setShowAghighSchool] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [guideCollapse, setGuideCollapse] = useState(false);
  const [borhanCollapse, setBorhanCollapse] = useState(false);
  const drawerSelect = useRef(null);

  useOutSideClick(drawerSelect, handleClose);

  const checkUrl = (url) => {
    axios
      .get(Apis.baseUrl + `a/act${url}`, {
        headers: {
          Authorization: `token ${localStorage.getItem("aghighToken")}`,
        },
      })
      .then((res) => {
        handleClose();
        history.push(`/associations${url}`);
      })
      .catch((err) => {
        handleClose();
        history.push("/not-found");
      });
  };

  const handleRemember = () => {
    setRemember(!remember);
  };
  const handleGuidCollapse = () => {
    setGuideCollapse(!guideCollapse);
  };
  const handleBorhanCollapse = () => {
    setBorhanCollapse(!borhanCollapse);
  };

  const handleSeenNotifications = (id) => {
    handleClose();
    setRemember(false);
    dispatch(setNotificationsSeen({ notificationId: id }));
  };

  const startTour = (step) => {
    setTimeout(
      () =>
        dispatch(
          setTour({ ...tour, run: true, tourActive: true, stepIndex: step })
        ),
      500
    );
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  useEffect(() => {
    if (
      currentUser?.menu?.election?.el1_slug ||
      currentUser?.menu?.election?.el2_slug ||
      currentUser?.menu?.election?.el3_slug ||
      currentUser?.menu?.election?.el4_slug ||
      currentUser?.menu?.election?.el5_slug
    ) {
      setShowElection(true);
    }
  }, [currentUser?.menu]);
  return (
    <Drawer
      className={classes.drawer}
      variant="temporary"
      anchor="left"
      open={open}
      transitionDuration={{ enter: 500, exit: 400 }}
      classes={{ paper: classes.drawerMenuPaper }}
    >
      <Grid
        container
        direction="column"
        wrap="nowrap"
        ref={drawerSelect}
        style={{ width: "100%", height: "100%" }}
      >
        <Grid
          direction="column"
          container
          className={classes.drawerHeaderContainer}
        >
          <Grid container justify="flex-end" style={{ padding: "10px 20px" }}>
            <CloseIcon onClick={handleClose} style={{ color: "#fff" }} />
          </Grid>
          <Grid
            container
            alignItems="center"
            className={classes.avatarAndNameContainer}
          >
            <Avatar
              src={currentUser.photo && Apis.imageUrl + currentUser.photo}
              className={classes.drawerAvatar}
            />
            <Grid
              container
              direction="column"
              style={{ width: "fit-content", flex: 1 }}
            >
              <Grid item className={classes.userNameDrawer}>
                {currentUser.name}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          direction="column"
          className={classes.drawerProfileContainer}
        >
          <ExitToAppRounded />
          <Grid
            container
            direction="column"
            justify="center"
            className={classes.drawerRow}
          >
            <Grid container alignItems="center">
              <img
                src={outlineUser}
                alt="outlineUser"
                style={{ width: 18, marginRight: 3 }}
              />
              <Grid
                item
                className={classes.drawerItem}
                component={Link}
                to={`/profile/${currentUser.slug}`}
                onClick={handleClose}
              >
                پروفایل من
              </Grid>
            </Grid>
            <Grid item className={classes.userRoleDrawer2}>
              {currentUser.roles?.map((item) => (
                <div
                  onClick={() => checkUrl(item.url)}
                  key={item.id}
                  style={{
                    marginRight: 45,
                    marginTop: 10,
                    display: "inline-block",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {item.role + " " + item.unit}
                </div>
              ))}
            </Grid>
          </Grid>

          <Grid
            container
            alignItems="center"
            className={classes.drawerRow}
            onClick={handleRemember}
          >
            <img
              src={RememberIcon}
              alt="RememberIcon"
              style={{ width: 18, marginRight: 3 }}
            />
            <Grid item className={classes.drawerItem}>
              یادآورها
            </Grid>
            <ExpandMoreRoundedIcon
              className={
                remember ? classes.arrowUpDrawer : classes.arrowDownDrawer
              }
            />
            {currentUser?.notifications?.length > 0 && (
              <Grid item className={classes.rememberCount}>
                <span>{currentUser?.notifications?.length}</span>
              </Grid>
            )}
          </Grid>
          <Collapse in={remember && currentUser?.notifications?.length > 0}>
            <Grid
              container
              direction="column"
              className={classes.rememberCollapseContainer}
            >
              <Grid
                container
                direction="column"
                wrap="nowrap"
                className={classes.allNotification}
              >
                {currentUser.notifications?.slice(0, 7)?.map((not, index) => {
                  return (
                    <Fragment key={not?.id}>
                      <Grid
                        container
                        className={classes.notificationItem}
                        component={Link}
                        to={{
                          pathname: not?.url,
                        }}
                        onClick={() => handleSeenNotifications(not?.id)}
                      >
                        <Grid container className={classes.notificationTitle}>
                          {not?.title}:
                        </Grid>
                        <Grid container className={classes.notificationBody}>
                          {not?.body}
                        </Grid>
                      </Grid>
                    </Fragment>
                  );
                })}
                <Collapse in={seeMore}>
                  {currentUser.notifications
                    ?.slice(8, currentUser.notifications?.length)
                    ?.map((not) => {
                      return (
                        <Fragment key={not?.id}>
                          <Grid
                            container
                            className={classes.notificationItem}
                            component={Link}
                            to={{
                              pathname: not?.url,
                            }}
                            onClick={() => handleSeenNotifications(not?.id)}
                          >
                            <Grid
                              container
                              className={classes.notificationTitle}
                            >
                              {not?.title}:
                            </Grid>
                            <Grid
                              container
                              className={classes.notificationBody}
                            >
                              {not?.body}
                            </Grid>
                          </Grid>
                        </Fragment>
                      );
                    })}
                </Collapse>
              </Grid>
              <Grid
                container
                justify="center"
                className={classes.seeMore}
                onClick={() => setSeeMore(!seeMore)}
              >
                {seeMore ? " بستن" : " بیشتر "}
              </Grid>
              <Grid
                container
                justify="center"
                className={classes.setSeenAll}
                onClick={() => handleSeenNotifications("all")}
              >
                حذف همه
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
        <Grid
          container
          direction="column"
          className={classes.drawerMenuItemContainer}
        >
          <Grid
            container
            className={classes.drawerItem}
            component={Link}
            to="/change-password"
            onClick={handleClose}
          >
            <img
              src={resetPassword}
              alt="resetPassword"
              style={{ width: 18, marginRight: 3, marginLeft: 3 }}
            />
            <Grid
              item
              className={classes.drawerItem}
              style={{ marginRight: 22 }}
            >
              تغییر رمز عبور
            </Grid>
          </Grid>
          <Grid
            container
            className={classes.drawerItem}
            component={Link}
            to="/"
            onClick={handleClose}
          >
            <img
              src={homeMobile}
              alt="homeMobile"
              style={{ width: 18, marginRight: 3, marginLeft: 3 }}
            />
            <Grid item className={classes.drawerItem}>
              خانه
            </Grid>
          </Grid>
          {/* <Grid
            container
            className={classes.drawerItem}
            component={Link}
            // to="/"
            to="/enghelab/school/activites"
            onClick={handleClose}
            style={{
              alignItems: "center",
            }}
          >
            <div className="animateDot"></div>
            <Grid item className={classes.drawerItem}>
              مدرسه انقلاب
            </Grid>
          </Grid> */}  
          <Grid
            container
            className={classes.drawerItem}
            component={Link}
            // to="/"
            to="/talayedaran"
            onClick={handleClose}
            style={{
              alignItems: "center",
            }}
          >
            <div className="animateDot"></div>
            <Grid item className={classes.drawerItem}>
              ثبت نام طلایه داران
            </Grid>
          </Grid>
          {/* <Grid
            container
            className={classes.drawerItem}
            component={Link}
            // to="/"
            to="/life-with-verses"
            onClick={handleClose}
            style={{
              alignItems: "center",
            }}
          >
            <div className="animateDot"></div>
            <Grid item className={classes.drawerItem}>
              عملیات رمضان المبارک
            </Grid>
          </Grid> */}
          {/* <Grid
            container
            className={classes.drawerItem}
            component={Link}
            // to="/"
            to="/enghelab/school/register"
            onClick={handleClose}
            style={{
              alignItems: "center",
            }}
          >
            <div className="animateDot"></div>
            <Grid item className={classes.drawerItem}>
              ثبت نام مدرسه انقلاب
            </Grid>
          </Grid> */}
          {/* <Grid
            container
            className={classes.drawerItem}
            component={Link}
            // to="/"
            to="/book/register"
            onClick={handleClose}
            style={{
              alignItems: "center",
            }}
          >
            <div className="animateDot"></div>
            <Grid item className={classes.drawerItem}>
              ثبت نام کتاب کار
            </Grid>
          </Grid> */}
          {showElection && (
            <Grid
              container
              className={classes.drawerItem}
              onClick={() => setShowElectionFade(!showElectionFade)}
              alignItems="center"
            >
              <img
                src={homeMobile}
                alt="homeMobile"
                style={{ width: 18, marginRight: 3, marginLeft: 3 }}
              />
              <span style={{ marginRight: 25 }}> انتخابات</span>
              <ExpandMoreRoundedIcon
                className={
                  showElectionFade
                    ? classes.arrowUpDrawer
                    : classes.arrowDownDrawer
                }
                style={{ marginRight: 7 }}
              />
            </Grid>
          )}
          <Grid container>
            <Collapse
              in={showElectionFade}
              classes={{ entered: classes.enterElectionCollapse }}
            >
              <Grid container direction="column" style={{ paddingRight: 45 }}>
                {currentUser?.menu?.election?.el1_slug && (
                  <Grid
                    container
                    className={classes.electionMenuItem}
                    component={Link}
                    to={`/election/${currentUser?.menu?.election?.el1_slug}`}
                    onClick={handleClose}
                  >
                    انتخابات دبیران منطقه‌ای و اعضای شهری
                  </Grid>
                )}
                {currentUser?.menu?.election?.el2_slug && (
                  <Grid
                    container
                    className={classes.electionMenuItem}
                    component={Link}
                    to={`/election/${currentUser?.menu?.election?.el2_slug}`}
                    onClick={handleClose}
                  >
                    انتخابات دبیران شهری و اعضای استانی
                  </Grid>
                )}
                {currentUser?.menu?.election?.el3_slug && (
                  <Grid
                    container
                    className={classes.electionMenuItem}
                    component={Link}
                    to={`/election/${currentUser?.menu?.election?.el3_slug}`}
                    onClick={handleClose}
                  >
                    انتخابات دبیران استان و اعضای ملی
                  </Grid>
                )}
                {currentUser?.menu?.election?.el4_slug && (
                  <Grid
                    container
                    className={classes.electionMenuItem}
                    component={Link}
                    to={`/election/${currentUser?.menu?.election?.el4_slug}`}
                    onClick={handleClose}
                  >
                    انتخابات دبیر ملی و عضو شورای مرکزی
                  </Grid>
                )}
              </Grid>
            </Collapse>
          </Grid>
          <Grid
            container
            className={classes.drawerItem}
            component={Link}
            to="/activities"
            onClick={handleClose}
          >
            <img
              src={activities}
              alt="activities"
              style={{ width: 18, marginRight: 3, marginLeft: 3 }}
            />
            <Grid item className={classes.drawerItem}>
              فعالیت‌ها
            </Grid>
          </Grid>
          <Grid
            container
            className={classes.drawerItem}
            component={Link}
            to="/league"
            onClick={handleClose}
          >
            <img
              src={ligue}
              alt="ligue"
              style={{ width: 18, marginRight: 3, marginLeft: 3 }}
            />
            <Grid item className={classes.drawerItem}>
              لیگ
            </Grid>
          </Grid>
          {/* <Grid container className={classes.drawerItem}>
						<img src={DanaBazarIcon} alt="DanaBazarIcon" style={{ width: 18, marginRight: 3, marginLeft: 3 }} />
						<a href="https://aghighdanabazar.ir/" className={classes.drawerItem}>
							دانابازار
						</a>
					</Grid> */}
          {/* <Grid container className={classes.drawerItem}>
						<img
							src={EducationalIcon}
							alt="educationalIcon"
							style={{ width: 18, marginRight: 3, marginLeft: 3 }}
						/>
						<a href="https://zobdehgan.com/" target="blank" className={classes.drawerItem}>
							خدمات علمی و درسی
						</a>
					</Grid> */}
          <Grid
            container
            alignItems="center"
            className={classes.drawerRow}
            onClick={handleGuidCollapse}
          >
            <img
              src={TourIcon}
              alt="TourIcon"
              style={{ width: 18, marginRight: 3 }}
            />
            <Grid item className={classes.drawerItem}>
              مدرسه عقیق
            </Grid>
            <ExpandMoreRoundedIcon
              className={
                guideCollapse ? classes.arrowUpDrawer : classes.arrowDownDrawer
              }
            />
          </Grid>
          <Collapse in={guideCollapse} style={{ minHeight: "fit-content" }}>
            <Grid
              container
              direction="column"
              style={{ backgroundColor: "#e8e8e8", paddingTop: "10px" }}
              l
            >
              <Grid
                container
                component={Link}
                className={classes.drawerItem2}
                to={`/associations/county/499`}
                onClick={() => {
                  setShowAghighSchool(false);
                  handleClose();
                }}
              >
                پایه هفتم
              </Grid>
              <Grid
                container
                className={classes.drawerItem2}
                component={Link}
                to={`/associations/county/500`}
                onClick={() => {
                  setShowAghighSchool(false);
                  handleClose();
                }}
              >
                پایه هشتم
              </Grid>
              <Grid
                container
                component={Link}
                className={classes.drawerItem2}
                to={`/associations/county/501`}
                onClick={() => {
                  setShowAghighSchool(false);
                  handleClose();
                }}
              >
                پایه نهم
              </Grid>
              <div className={classes.menuAccordionRoot}>
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography className={classes.drawerItem}>
                      پایه دهم
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container direction="column">
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/502`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleClose();
                        }}
                      >
                        ریاضی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/503`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleClose();
                        }}
                      >
                        تجربی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/504`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleClose();
                        }}
                      >
                        انسانی
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChange("panel2")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                  >
                    <Typography className={classes.drawerItem}>
                      پایه یازدهم
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container direction="column">
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/506`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleClose();
                        }}
                      >
                        ریاضی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/507`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleClose();
                        }}
                      >
                        تجربی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/505`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleClose();
                        }}
                      >
                        انسانی
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChange("panel3")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                  >
                    <Typography className={classes.drawerItem}>
                      پایه دوازدهم
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container direction="column">
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/508`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleClose();
                        }}
                      >
                        ریاضی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/509`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleClose();
                        }}
                      >
                        تجربی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/510`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleClose();
                        }}
                      >
                        انسانی
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </div>
            </Grid>
          </Collapse>
          <Grid
            container
            alignItems="center"
            className={classes.drawerRow}
            onClick={handleBorhanCollapse}
          >
            <img
              src={TourIcon}
              alt="TourIcon"
              style={{ width: 18, marginRight: 3 }}
            />
            <Grid item className={classes.drawerItem}>
              برهان
            </Grid>
            <ExpandMoreRoundedIcon
              className={
                borhanCollapse ? classes.arrowUpDrawer : classes.arrowDownDrawer
              }
            />
          </Grid>
          <Collapse in={borhanCollapse} style={{ minHeight: "fit-content" }}>
            <Grid
              container
              direction="column"
              style={{ backgroundColor: "#e8e8e8", paddingTop: "10px" }}
              l
            >
              <Grid
                container
                component={Link}
                className={classes.drawerItem2}
                to={`/associations/county/514`}
                onClick={() => {
                  setShowAghighSchool(false);
                  handleClose();
                }}
              >
                دوره پیش نیاز
              </Grid>
              <Grid
                container
                className={classes.drawerItem2}
                component={Link}
                to={`/associations/county/515`}
                onClick={() => {
                  setShowAghighSchool(false);
                  handleClose();
                }}
              >
                دوره کاردو مجازی
              </Grid>
            </Grid>
          </Collapse>
          <Grid
            container
            className={classes.drawerItem}
            component={Link}
            to="/messaging/inbox"
            onClick={handleClose}
          >
            <img
              src={speak}
              alt="messaging"
              style={{ width: 18, marginRight: 3, marginLeft: 3 }}
            />
            <Grid item className={classes.drawerItem}>
              گفتگو/همراز
            </Grid>
          </Grid>
          {currentUser?.menu?.election && (
            <Grid
              container
              className={classes.drawerItem}
              component={Link}
              to="/election"
              onClick={() => {
                handleClose();
              }}
            >
              <img
                src={EducationalIcon}
                alt="EducationalIcon"
                style={{ width: 18, marginRight: 3, marginLeft: 3 }}
              />
              <Grid item className={classes.drawerItem}>
                انتخابات قرارگاه ملی
              </Grid>
            </Grid>
          )}
          <Grid
            container
            item
            className={classes.drawerRow}
            component={Link}
            to={`/counter`}
            onClick={() => {
              handleClose();
            }}
          >
            <img
              src={CounterIcon}
              alt="counter"
              style={{ width: 18, marginRight: 3, marginLeft: 3 }}
            />
            <Grid item className={classes.drawerItem}>
              پیشخوان
            </Grid>
          </Grid>
          <Grid
            container
            item
            className={classes.drawerRow}
            component={Link}
            to="/ideation/convocation"
            onClick={() => {
              handleClose();
            }}
          >
            <img
              src={CounterIcon}
              alt="counter"
              style={{ width: 18, marginRight: 3, marginLeft: 3 }}
            />
            <Grid item className={classes.drawerItem}>
              ایدنو
            </Grid>
          </Grid>
          {/* <Grid
            container
            item
            className={classes.drawerRow}
            component={Link}
            to="/enghelab/school"
            onClick={() => {
              handleClose();
            }}
          >
            <img
              src={CounterIcon}
              alt="counter"
              style={{ width: 18, marginRight: 3, marginLeft: 3 }}
            />
            <Grid item className={classes.drawerItem}>
              مدرسه انقلاب
            </Grid>
          </Grid> */}
          {/* <Grid container className={classes.drawerItem}>
                        <img src={speak} alt="speak" style={{ width: 18, marginRight: 3, marginLeft: 3 }} />
                        <Grid item className={classes.drawerItem}>
                            گفتگو
                        </Grid>
                    </Grid> */}
          {/* <Grid container className={classes.drawerItem}>
                        <img src={userTag} alt="userTag" style={{ width: 18, marginRight: 3, marginLeft: 3 }} />
                        <Grid item className={classes.drawerItem}>
                            مدیر فراخوان
                        </Grid>
                    </Grid> */}
          {/* <Grid container className={classes.drawerItem}>
                        <img src={sport} alt="sport" style={{ width: 18, marginRight: 3, marginLeft: 3 }} />
                        <Grid item className={classes.drawerItem}>
                            باشگاه
                        </Grid>
                    </Grid> */}
          {/* <Grid container className={classes.drawerItem}>
                        <img
                            src={outlineRanking}
                            alt="outlineRanking"
                            style={{ width: 18, marginRight: 3, marginLeft: 3 }}
                        />
                        <Grid item className={classes.drawerItem}>
                            انجمن برتر
                        </Grid>
                    </Grid> */}
          <Grid
            container
            alignItems="center"
            direction="column"
            justify="center"
            // className={classes.exitContainer}
            onClick={() => {
              localStorage.removeItem("aghighToken");
              dispatch(logOut());
              history.push("/");
              handleClose();
            }}
          >
            <img src={exitIcon} style={{ width: 30 }} alt="exitIcon" />
            <span className={classes.exitText}>خروج</span>
          </Grid>
        </Grid>
      </Grid>
    </Drawer>
  );
}
